import { parsePhoneNumberWithError } from 'libphonenumber-js'
import { CountryCode } from 'libphonenumber-js/types.cjs'

export const formatPhoneNumber = (
  countryCode: CountryCode,
  phoneNumber: string,
): string => {
  const parsedPhoneNumber = parsePhoneNumberWithError(phoneNumber, countryCode)
  return parsedPhoneNumber.formatInternational()
}
